import QueryString from "qs"
import http from "../index"
import {apiListCustomerContract,apiGetCustomerContractDetail,apiCreateCustomerContract,apiUpdateCustomerContract, apiListCustomer, apiListLeaderContract} from "./urls"
const listContractCustomer = params  => http.get(apiListCustomerContract,{params})
const getContractCustomerDetail = (id) => http.get(`/1.0/wsm/contract/customer/${id}/detail`);
const createContractcustomer = body => http.post(apiCreateCustomerContract, body)
const getListCustomer = (params) => http.get(apiListCustomer, params)
const updateContractcustomer = (id, body) => http.post(apiUpdateCustomerContract(id), body)
const updateStatusBrowse = (id, body) => http.put(`1.0/wsm/contract/customer/${id}/browse`, body)
const updateStatusRefuse = (id, body) => http.put(`1.0/wsm/contract/customer/${id}/refuse`, body)
const updateStatusSigned = (id, body) => http.put(`1.0/wsm/contract/customer/${id}/signed`, body)

const listContractLeader = params  => http.get(apiListLeaderContract,{params})
const getContractLeaderDetail = (id) => http.get(`/1.0/wsm/leader/contract/${id}/detail`);
const deleteFile = (id) => http.delete(`1.0/wsm/contract/customer/${id}/delete`)
const renewCustomerContract = (id, body) =>http.put(`1.0/wsm/contract/customer/${id}/renew`, body)

const ContractCustomerService = {
  listContractCustomer,
  getContractCustomerDetail,
  createContractcustomer,
  updateContractcustomer,
  getListCustomer,
  updateStatusBrowse,
  updateStatusRefuse,
  updateStatusSigned,
  listContractLeader,
  getContractLeaderDetail,
  deleteFile,
  renewCustomerContract
}
export default ContractCustomerService